<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0"
                 fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    business
                </mat-icon>
                <span class="logo-text h1">
                    Carteira Consórcio
                </span>
            </div>
            <!-- / APP TITLE -->
    
            <!-- ADD BUTTON -->

            <div class="add-product-button mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                <!-- ADD BUTTON -->
                <button mat-raised-button mat-icon-button [matMenuTriggerFor]="animals">
                    <mat-icon>settings_applications</mat-icon>
                </button>
                <!-- / ADD BUTTON -->
                <mat-menu #animals="matMenu">
                    <button mat-menu-item (click)="openCadastro()">
                        <mat-icon>add_circle</mat-icon>
                        NOVA CARTEIRA
                    </button>
                    
                </mat-menu>
            </div>       
            <!-- / ADD BUTTON -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                [rows]='rows'>

                <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="false" [width]="400">
                    <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                        {{ cliente.nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Tipo Consórcio" prop="tipo_consorcio" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-tipo_consorcio="value" ngx-datatable-cell-template>
                        {{ tipo_consorcio.nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Empresa" prop="empresa_consorcio" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-empresa_consorcio="value" ngx-datatable-cell-template>
                        {{ empresa_consorcio.nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                        <button mat-icon-button matTooltip="Alterar Ação" (click)="openAlterar(id)">
                            <mat-icon aria-label="Alterar Ação">edit</mat-icon>
                        </button>

                        <button mat-icon-button color="warn" matTooltip="Excluir Ação" (click)="delete(id)">
                            <mat-icon aria-label="Excluir Ação">delete</mat-icon>
                        </button>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>